import { render } from "./Information.vue?vue&type=template&id=37ff1663"
import script from "./Information.vue?vue&type=script&lang=ts"
export * from "./Information.vue?vue&type=script&lang=ts"
script.render = render

export default script